import { render } from "./declaration-of-consent.vue?vue&type=template&id=0712e041"
import script from "./declaration-of-consent.vue?vue&type=script&lang=js"
export * from "./declaration-of-consent.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__